<template>
  <div class="container">
    <breadcrumb v-if="!isMobile" crumb="managers-list" />
    <section v-if="!isMobile" class="managers_section_filter">
      <el-row>
        <el-col :span="12">
          <search-input
            placeholder="Поиск по ФИО менеджера"
            @clear="clearFilter"
            @input="onInput"
          />
        </el-col>
        <el-col :span="12" class="top-section-right">
          <div class="center" style="justify-content: flex-end">
            <p @click="$router.push({ path: '/managers/add' })">
              Добавить менеджера
            </p>
          </div>
        </el-col>
      </el-row>
      <p class="select-all-d">
        <el-checkbox
          v-if="managersList.length && !loading"
          v-model="checkAll"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
        >
          Выбрать все
        </el-checkbox>
      </p>
    </section>
    <section v-if="isMobile" class="top-section" style="padding-bottom: 20px">
      <el-button
        type="primary"
        style="width: 100% !important"
        @click="$router.push({ path: '/managers/add' })"
      >
        Добавить менеджера
      </el-button>
    </section>
    <el-table
      v-if="loading || !managersList.length"
      v-loading="loading"
      :data="managersList"
      style="width: 100%; height: 40vh; margin-top: 40px"
    />
    <section
      v-if="managersList.length && !loading"
      class="middle-section middle-section_managers"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-checkbox-group v-model="checked" @change="handleCheckedChange">
            <transition-group name="slide-fade" tag="div">
              <div
                v-for="m in managersList"
                :key="m.id"
                class="check-list"
                @click="infoManager(m, $event)"
              >
                <el-row :gutter="24" type="flex" align="middle">
                  <el-col v-if="!isMobile" class="auto-list_col" :span="1">
                    <div class="check-list-time auto-list_col_centered">
                      <el-checkbox :label="m" :value="m" />
                    </div>
                  </el-col>
                  <el-col class="auto-list_col" :xs="14" :sm="7">
                    <div
                      class="check-list-person auto-list_col_centered"
                      :style="isMobile ? 'text-align:center' : ''"
                    >
                      <p>{{ shortFio(m.profile.fio.trim()) }}</p>
                    </div>
                  </el-col>
                  <el-col v-if="!isMobile" class="auto-list_col" :span="7">
                    <div class="check-list-person grey check-list_phone">
                      <p>{{ m.phone }}</p>
                    </div>
                  </el-col>
                  <el-col v-if="!isMobile" class="auto-list_col" :span="6">
                    <div class="check-list-person grey check-list_phone">
                      <p>{{ m.profile.email }}</p>
                    </div>
                  </el-col>
                  <el-col class="auto-list_col double_button" :xs="8" :sm="2">
                    <div class="check-list-action">
                      <p>
                        <el-button
                          data-goal="1"
                          type="danger"
                          icon="el-icon-delete"
                          class="no-events"
                          circle
                          @click="beforeDelete(m.id)"
                        />
                      </p>
                      <p>
                        <el-button
                          type="success"
                          icon="el-icon-edit"
                          class="no-events"
                          circle
                          @click="infoManager(m, $event, 1)"
                        />
                      </p>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </transition-group>
          </el-checkbox-group>
        </el-col>
      </el-row>
    </section>

    <section
      v-if="!isMobile && managersList.length && !loading"
      class="bottom-section"
    >
      <div class="bottom-section-action">
        <p>Выбрано {{ checked.length }} менеджеров</p>
        <el-col class="auto-list_col" :span="4">
          <el-button
            type="info"
            plain
            :disabled="!checked.length"
            @click="beforeDelete()"
          >
            <p>Удалить</p>
          </el-button>
        </el-col>
      </div>
    </section>
    <el-dialog
      title="Редактирование менеджера"
      :visible.sync="dialog_manager"
      width="80%"
    >
      <manager-form :man="manager" @close="onClose" />
    </el-dialog>
  </div>
</template>

<script>
import { DELETE_MANAGER } from '@/store/actions/managers'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import ManagerForm from '@/components/Forms/ManagerForm'
import SearchInput from '@/components/Shared/SearchInput'

const Managers = RepositoryFactory.get('managers')

export default {
  name: 'ManagersList',
  components: {
    Breadcrumb,
    SearchInput,
    ManagerForm,
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      checked: [],
      dialog_manager: false,
      search_input: '',
      manager: {},
    }
  },
  mounted() {
    this.loadPage()
  },
  computed: {
    ...mapGetters({
      loading: 'managers/getLoading',
      managers: 'managers/getManagers',
    }),
    managersList() {
      let filterSearch = String(this.search_input).trim()
      const search = filterSearch ? filterSearch.toLowerCase() : ''

      return !search
        ? this.managers
        : this.managers.filter(m => {
            const fio =
              m.profile && m.profile.fio ? m.profile.fio.toLowerCase() : ''

            return fio && fio.includes(search)
          })
    },
  },
  methods: {
    async loadPage() {
      await this.getList()
    },
    onInput(cur) {
      this.search_input = cur
    },
    async getList() {
      await this.$store.dispatch('managers/fetchManagers')
    },
    clearFilter() {
      this.search_input = ''
      this.getList()
    },
    handleCheckAllChange(val) {
      this.checked = val ? this.managersList : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      const checkedCount = value.length

      this.checkAll = checkedCount === this.managersList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.managersList.length
    },
    infoManager(manager, e, flag = false) {
      if (this.isMobile && !flag) {
        return false
      }
      const val = e.target.classList.value

      if (!e.target.dataset.goal && val.indexOf('el-checkbox') === -1) {
        this.manager = { ...manager }
        this.dialog_manager = true
      }
    },
    onClose() {
      this.manager = {}
      this.dialog_manager = false
      this.getList()
    },
    beforeDelete(id = 0) {
      this.$confirm('Вы уверены что хотите удалить?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
        customClass: this.isMobile ? 'before-del' : '',
      }).then(() => {
        if (id) {
          this.deleteItem(id)
        } else {
          this.dellArrItems()
        }
      })
    },
    dellArrItems() {
      for (let index = 0; index < this.checked.length; index++) {
        const element = this.checked[index]

        Managers.deleteItem(element.id).then(() => {
          this.$store.commit(`managers/${DELETE_MANAGER}`, { id: element.id })
        })
      }
    },
    deleteItem(id) {
      Managers.deleteItem(id).then(() => {
        this.$store.commit(`managers/${DELETE_MANAGER}`, { id })
      })
    },
  },
}
</script>

<style lang="sass">
.el-message-box.before-del
  width: 90%
.no-events
  i
    pointer-events: none
.managers_section_filter
  padding: 0 15px
  .top-section-left
    position: relative
    .search-input
      margin: 30px 0 15px 0
  .select-all-d
    margin: 0
    &:hover
      cursor: pointer
      text-decoration: underline
      .el-checkbox__label
        color: #3498DB
        text-decoration: underline
  .top-section-right
    p
      font-size: 18px
      line-height: 21px
      color: #3498DB
      &:hover
        text-decoration: underline
        cursor: pointer
    .center
      display: flex
      align-items: center
      justify-content: space-between
      span
        margin-left: 14px

.middle-section
  .check-list
    cursor: pointer
    margin: 20px 0
    background: #fff
    align-items: center
    height: 100px
    .el-checkbox__label
        display: none
    .auto-list_col
      height: 100px
      text-align: center
      .auto-list_col_centered
        height: 100%
        display: grid
        align-items: center
    .check-list-time
      text-align: center
    .check-list-phone
      font-size: 16px
      line-height: 21px
    .check-list-autos
      font-size: 14px
      line-height: 21px
    .check-list-action
      img
          margin: 10px
      .single-p
        font-size: 18px
        text-align: center
        color: #dd6161
        &.is6
          color: limegreen
    .check-list-person
      p
        margin: 5px
        font-size: 18px
        line-height: 22px
    .grey
      color: #98A9BC
    .doc-phone
      border: none
      font-size: 18px
      color: #98A9BC
      outline: none
      cursor: pointer

.bottom-section
  .pagination
    margin-bottom: 20px
    display: flex
    justify-content: flex-end
  .el-dialog, .el-pager li
    background: transparent
  .bottom-section-action
    display: flex
    align-items: center
    justify-content: flex-end
    p
      font-size: 14px
      line-height: 17px
      text-transform: uppercase
      font-weight: bold
      margin: 0
    .el-button
      margin-left: 30px
      border: none
      border-radius: unset
      background: #E9E9E9
/*added new style*/
.middle-section.middle-section_managers
  .check-list
    .el-row
      height: 100%
    .check-list-person
      p
        margin: 0
    .check-list_phone, .check-list_date
      p
        font-size: 16px
        font-weight: normal
    .check-list_date
      p
        text-align: center
        line-height: 1
    .el-rate
      height: auto
    .auto-list_col
      height: auto
    .check-list-time
      padding-left: 25px
    .double_button
      margin-right: 35px
      .check-list-action
        display: flex
        p
          margin: 0 5px
    .black_color
      color: #000000
    .red_color
      color: rgb(255, 0, 0)
</style>
